
export class Page {
  pageSize?: number;
  pageIndex?: number;
  sortInfo?: [{ property: string; direction: number } | null] | null;
}
